import { ReactNode } from 'react'

type PropsType = {
  children: ReactNode
}

const Toolbar = ({ children }: PropsType) => {
  return <div className="border-border flex flex-wrap gap-2 border-b p-1">{children}</div>
}

export default Toolbar
